import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  submitForm() {
    const form = event.currentTarget.closest("form");
    if (form) {
      if (form.dataset.remote === "true") {
        Rails.fire(form, "submit"); // Rails UJS AJAX
      } else {
        form.submit(); // Native browser form submission
      }
    }
  }
}
